import {
    infobarMessageSMIMEDomainNotAllowedExtensionOptionPage,
    infobarMessageSMIMEDomainNotAllowedRestartApprove,
    infobarMessageSMIMECannotFetchDataPackageText,
    infobarMessageSMIMECannotParseMimeContentText,
    infobarMessageSMIMECannotBuildMimeContentText,
    infobarMessageSMIMECannotAcquireCspContextText,
    infobarMessageSMIMECannotEncodeSigningTimeText,
    infobarMessageSMIMECannotOpenMsgToEncodeText,
    infobarMessageSMIMECannotOpenMsgToDecodeText,
    infobarMessageSMIMECannotProcessMessageText,
    infobarMessageSMIMECannotGetMessageParamText,
    infobarMessageSMIMECannotGetCertContextPropertyText,
    infobarMessageSMIMECannotGetSigningTimesText,
    infobarMessageSMIMECannotGetCertsInMessageText,
    infobarMessageSMIMECannotAddSignerToMessageText,
    infobarMessageSMIMECannotAddCertsToMessageText,
    infobarMessageSMIMECannotOpenCertStoreText,
    infobarMessageSMIMECannotGetSubjectCertFromStoreText,
    infobarMessageSMIMEUserCanceledSelectingCertText,
    infobarMessageSMIMECannotAccessSmartcardText,
    infobarMessageSMIMECannotEncodeSmimeCapabilitiesText,
    infobarMessageSMIMEControlOutOfDate,
    infobarMessageSMIMEBrowserNotSupported,
    infobarMessageSMIMEControlOutOfDateSigned,
    infobarMessageSMIMEControlOutOfDateCannotOpenMessage,
    infobarMessageSMIMEControlNotSupportedSigned,
    infobarSMIMEExtensionNotInstalledByAdminOnSignedMessage,
    infobarSMIMEControlNotInstalledSigned,
    infobarSMIMEInstallPrefixText,
    infobarMessageSMIMEMissingExtensionByAdmin,
    infobarMessageSMIMEMissingControl,
    infobarMessageSMIMEMissingControlOnCompose,
    infobarMessageSMIMEMissingControlOnComposeWithOptionByAdmin,
    infobarMessageSMIMECannotVerifyChoosenCertificate,
    infobarMessageSMIMEChosenCertificateIsInvalid,
    infobarMessageSMIMEChosenCertificateIsRevoked,
    infobarMessageSMIMEChosenCertificateIsUntrusted,
    infobarMessageSMIMECannotGetCerts,
    infobarMessageSMIMEQuotedBodyIsNotComplete,
    infobarMessageSMIMEUserSettingNotApplied,
    infobarMessageSMIMEReplyOrForwardNonSmime,
    infobarMessageSMIMEControlOutOfDateReplyForward,
    infobarMessageSMIMEBrowserNotSupportedOnReplyToMessage,
    infobarMessageSMIMEBrowserNotSupportedOnForwardOfMessage,
} from './getSmimeInfobarMessageFromErrorCode.locstring.json';
import { infoLinkClickHere } from 'owa-locstrings/lib/strings/infolinkclickhere.locstring.json';
import {
    infobarMessageSMIMEUnknownErrorText,
    infobarMessageSMIMECannotVerifyText,
    infobarMessageSMIMECannotDecryptText,
} from '../strings.locstring.json';
import loc, { format } from 'owa-localize';
import doesBrowserSupportModernExtension from 'owa-smime-adapter/lib/utils/doesBrowserSupportModernExtension';
import { InfoBarCustomAction, MessagePart } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import SmimeErrorStateEnum from 'owa-smime-adapter/lib/store/schema/SmimeErrorStateEnum';
import downloadSmimeControl from 'owa-smime-adapter/lib/utils/downloadSmimeControl';
import { lazySmimeAdapter } from 'owa-smime-adapter';

import getSmimeErrorContextStringForInfobar from './getSmimeErrorContextStringForInfobar';
import SmimeContext from '../store/schema/SmimeContext';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

const clickHereInfoBarCustomAction = (): InfoBarCustomAction => ({
    text: loc(infoLinkClickHere),
    action: () => downloadSmimeControl(),
});

const getDomainRejectedMessageParts = (contextString: string): [string, ...MessagePart[]] => {
    return doesBrowserSupportModernExtension()
        ? [
              format(contextString, loc(infobarMessageSMIMEDomainNotAllowedExtensionOptionPage)),
              {
                  text: loc(infoLinkClickHere),
                  action: async () => {
                      const smimeAdapter = await lazySmimeAdapter.import();
                      smimeAdapter && smimeAdapter.openExtensionOptionsPage();
                  },
              },
          ]
        : [format(contextString, loc(infobarMessageSMIMEDomainNotAllowedRestartApprove))];
};

const getSmimeInfobarMessageFromErrorCode = (
    errorCode: SmimeErrorStateEnum,
    smimeContext: SmimeContext
): [string, ...MessagePart[]] => {
    const context: string = getSmimeErrorContextStringForInfobar(smimeContext);

    switch (errorCode) {
        case SmimeErrorStateEnum.CannotDecrypt:
            return [format(loc(infobarMessageSMIMECannotDecryptText))];
        case SmimeErrorStateEnum.CannotVerify:
        case SmimeErrorStateEnum.CannotVerifyOpaque:
            return [format(loc(infobarMessageSMIMECannotVerifyText))];
        case SmimeErrorStateEnum.CannotFetchDataPackage:
            return [loc(infobarMessageSMIMECannotFetchDataPackageText)];
        case SmimeErrorStateEnum.CannotParseMimeContent:
            return [format(context, loc(infobarMessageSMIMECannotParseMimeContentText))];
        case SmimeErrorStateEnum.CannotBuildMimeContent:
            return [format(context, loc(infobarMessageSMIMECannotBuildMimeContentText))];
        case SmimeErrorStateEnum.CannotAcquireCspContext:
            return [format(context, loc(infobarMessageSMIMECannotAcquireCspContextText))];
        case SmimeErrorStateEnum.CannotEncodeSigningTime:
            return [format(context, loc(infobarMessageSMIMECannotEncodeSigningTimeText))];
        case SmimeErrorStateEnum.CannotOpenMsgToEncode:
            return [format(context, loc(infobarMessageSMIMECannotOpenMsgToEncodeText))];
        case SmimeErrorStateEnum.CannotOpenMsgToDecode:
            return [format(context, loc(infobarMessageSMIMECannotOpenMsgToDecodeText))];
        case SmimeErrorStateEnum.CannotProcessMessage:
            return [format(context, loc(infobarMessageSMIMECannotProcessMessageText))];
        case SmimeErrorStateEnum.CannotGetMessageParam:
            return [format(context, loc(infobarMessageSMIMECannotGetMessageParamText))];
        case SmimeErrorStateEnum.CannotGetCertContextProperty:
            return [format(context, loc(infobarMessageSMIMECannotGetCertContextPropertyText))];
        case SmimeErrorStateEnum.CannotGetSigningTimes:
            return [format(context, loc(infobarMessageSMIMECannotGetSigningTimesText))];
        case SmimeErrorStateEnum.CannotGetCertsInMessage:
            return [format(context, loc(infobarMessageSMIMECannotGetCertsInMessageText))];
        case SmimeErrorStateEnum.CannotAddSignerToMessage:
            return [format(context, loc(infobarMessageSMIMECannotAddSignerToMessageText))];
        case SmimeErrorStateEnum.CannotAddCertsToMessage:
            return [format(context, loc(infobarMessageSMIMECannotAddCertsToMessageText))];
        case SmimeErrorStateEnum.CannotOpenCertStore:
            return [format(context, loc(infobarMessageSMIMECannotOpenCertStoreText))];
        case SmimeErrorStateEnum.CannotGetSubjectCertFromStore:
            return [format(context, loc(infobarMessageSMIMECannotGetSubjectCertFromStoreText))];
        case SmimeErrorStateEnum.UserCanceledSelectingCert:
            return [format(context, loc(infobarMessageSMIMEUserCanceledSelectingCertText))];
        case SmimeErrorStateEnum.CannotAccessSmartcard:
            return [format(context, loc(infobarMessageSMIMECannotAccessSmartcardText))];
        case SmimeErrorStateEnum.CannotEncodeSmimeCapabilities:
            return [format(context, loc(infobarMessageSMIMECannotEncodeSmimeCapabilitiesText))];
        case SmimeErrorStateEnum.DomainRejectedError:
            return getDomainRejectedMessageParts(context);
        case SmimeErrorStateEnum.ControlOutOfDateCompatible:
            return [loc(infobarMessageSMIMEControlOutOfDate), clickHereInfoBarCustomAction()];
        case SmimeErrorStateEnum.ControlNotSupported:
            return [loc(infobarMessageSMIMEBrowserNotSupported)];
        case SmimeErrorStateEnum.ControlOutOfDateSigned:
            return [loc(infobarMessageSMIMEControlOutOfDateSigned), clickHereInfoBarCustomAction()];
        case SmimeErrorStateEnum.ControlOutOfDateCantOpenMessage:
            return [
                loc(infobarMessageSMIMEControlOutOfDateCannotOpenMessage),
                clickHereInfoBarCustomAction(),
            ];
        case SmimeErrorStateEnum.ControlNotSupportedOnSignedMessage:
            return [loc(infobarMessageSMIMEControlNotSupportedSigned)];
        case SmimeErrorStateEnum.ExtensionNotInstalledOnSignedMessageWithOptionToInstallByAdmin:
            return [format(context, loc(infobarSMIMEExtensionNotInstalledByAdminOnSignedMessage))];
        case SmimeErrorStateEnum.ControlNotInstalledOnSignedMessageWithOptionToInstall:
            return [
                loc(infobarSMIMEControlNotInstalledSigned),
                loc(infobarSMIMEInstallPrefixText),
                clickHereInfoBarCustomAction(),
            ];
        case SmimeErrorStateEnum.ExtensionNotInstalledOnEncryptedMessageWithOptionToInstallByAdmin:
            return [format(context, loc(infobarMessageSMIMEMissingExtensionByAdmin))];
        case SmimeErrorStateEnum.ControlNotInstalledOnEncryptedMessageWithOptionToInstall:
            return [
                loc(infobarMessageSMIMEMissingControl),
                loc(infobarSMIMEInstallPrefixText),
                clickHereInfoBarCustomAction(),
            ];
        case SmimeErrorStateEnum.ControlNotInstalledOnComposeWithoutOptionToInstall:
            return [loc(infobarMessageSMIMEMissingControlOnCompose)];
        case SmimeErrorStateEnum.ExtensionNotInstalledOnComposeWithOptionToInstallByAdmin:
            return [loc(infobarMessageSMIMEMissingControlOnComposeWithOptionByAdmin)];
        case SmimeErrorStateEnum.ControlNotInstalledOnComposeWithOptionToInstall:
            return [
                loc(infobarMessageSMIMEMissingControlOnCompose),
                loc(infobarSMIMEInstallPrefixText),
                clickHereInfoBarCustomAction(),
            ];
        case SmimeErrorStateEnum.WarningSmimeCannotVerifyChosenCertificate:
            return [format(context, loc(infobarMessageSMIMECannotVerifyChoosenCertificate))];
        case SmimeErrorStateEnum.WarningSmimeChosenCertificateIsInvalid:
            return [format(context, loc(infobarMessageSMIMEChosenCertificateIsInvalid))];
        case SmimeErrorStateEnum.WarningSmimeChosenCertificateIsRevoked:
            return [format(context, loc(infobarMessageSMIMEChosenCertificateIsRevoked))];
        case SmimeErrorStateEnum.WarningSmimeChosenCertificateIsUntrusted:
            return [format(context, loc(infobarMessageSMIMEChosenCertificateIsUntrusted))];
        case SmimeErrorStateEnum.WarningSmimeCannotGetCerts:
            return [format(context, loc(infobarMessageSMIMECannotGetCerts))];
        case SmimeErrorStateEnum.QuotedBodyIsNotComplete:
            return [loc(infobarMessageSMIMEQuotedBodyIsNotComplete)];
        case SmimeErrorStateEnum.DataPackageTooLarge:
            return [
                format(
                    loc(infobarMessageSMIMEBrowserNotSupported),
                    getUserConfiguration().SessionSettings.MaxMessageSizeInKb / 1024
                ),
            ];
        case SmimeErrorStateEnum.warningUserSettingNotApplied:
            return [loc(infobarMessageSMIMEUserSettingNotApplied)];
        case SmimeErrorStateEnum.warningReplyOrForwardNotSmime:
            return [loc(infobarMessageSMIMEReplyOrForwardNonSmime)];
        case SmimeErrorStateEnum.ControlOutOfDateReplyForward:
            return [
                loc(infobarMessageSMIMEControlOutOfDateReplyForward),
                clickHereInfoBarCustomAction(),
            ];
        case SmimeErrorStateEnum.ControlNotSupportedOnReplyToMessageWithoutOptionToInstall:
            return [loc(infobarMessageSMIMEBrowserNotSupportedOnReplyToMessage)];
        case SmimeErrorStateEnum.ControlNotSupportedOnForwardOfMessageWithoutOptionToInstall:
            return [loc(infobarMessageSMIMEBrowserNotSupportedOnForwardOfMessage)];
        case SmimeErrorStateEnum.UnknownError:
        case SmimeErrorStateEnum.CannotParseEncryptionAlgorithms:
        case SmimeErrorStateEnum.CannotParseSigningAlgorithms:
        default:
            return [format(context, loc(infobarMessageSMIMEUnknownErrorText))];
    }
};

export default getSmimeInfobarMessageFromErrorCode;
